import { i as isObject } from './isObject-CgRrra7h-CgRrra7h.js';

/**
 * @description Method to perform a deep merge of objects
 * @param {Object} target - The targeted object that needs to be merged with the supplied @sources
 * @param {Array<Object>} sources - The source(s) that will be used to update the @target object
 * @return {Object} The final merged object
 *
 * Example: deepMerge(
 *   { a: 'something', b: 'somethingElse' }, // target
 *   { b: 'somethingNew', c: 'anotherThing' }, // sources
 *   { c: 'somethingCompletelyDifferent' }, // sources
 *  ) => { a: 'something', b: 'somethingNew', c: 'somethingCompletelyDifferent' }
 */

const deepMerge = (target, ...sources) => {
  // return the target if no sources passed
  if (!sources.length) {
    return target;
  }
  const result = target;
  if (isObject(result)) {
    const len = sources.length;
    for (let i = 0; i < len; i += 1) {
      const elm = sources[i];
      if (isObject(elm)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in elm) {
          if (Object.prototype.hasOwnProperty.call(elm, key)) {
            if (isObject(elm[key]) && typeof elm[key] !== 'function') {
              if (!result[key] || !isObject(result[key])) {
                result[key] = {};
              }
              deepMerge(result[key], elm[key]);
            } else if (Array.isArray(result[key]) && Array.isArray(elm[key])) {
              // concatenate the two arrays and remove any duplicate primitive values
              result[key] = Array.from(new Set(result[key].concat(elm[key])));
            } else {
              // Handle both regular values and functions
              result[key] = elm[key];
            }
          }
        }
      }
    }
  }
  return result;
};

export { deepMerge as d };
//# sourceMappingURL=deepMerge-DnBOZDdk-CPJEa3wD.js.map
